import type { PropsWithChildren } from 'react';
// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const AvatarContainer = styled('div', {
  base: {
    position: 'relative',
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const AvatarCircle = styled('div', {
  base: {
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '50%',
    backgroundColor: 'brand',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    boxSizing: 'content-box',
  },
  variants: {
    withBorder: {
      true: {
        border: '2px solid white',
      },
      false: {},
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const InstagramOutline = styled('div', {
  base: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: '-2px',
    borderRadius: '50%',
    background: 'linear-gradient(to right, #c913b9, #f9373f, #f9373f, #fecd00)',
  },
});

export const ZillowAvatarImage = ({
  size,
  withInstagramBorder,
  children,
}: PropsWithChildren<{ size: number; withInstagramBorder?: boolean }>) => {
  const containerStyle = {
    width: `${withInstagramBorder ? size + 4 : size}px`,
    height: `${withInstagramBorder ? size + 4 : size}px`,
  };

  const circleStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <AvatarContainer style={containerStyle}>
      {withInstagramBorder && <InstagramOutline />}
      <AvatarCircle withBorder={withInstagramBorder} style={circleStyle}>
        {children}
      </AvatarCircle>
    </AvatarContainer>
  );
};
